import { Info } from "lucide-react";
import MenuIconTooltip from "./MenuIconTooltip";

export default function VocabInfoTip({
  tooltip,
  ariaLabel,
  className = "",
  placement = "above",
  zIndex,
}) {
  return (
    <MenuIconTooltip
      tooltip={tooltip}
      placement={placement}
      portal
      className={className}
      zIndex={zIndex}
    >
      <button
        type="button"
        className="vocab-info-button"
        aria-label={ariaLabel}
        onMouseDown={(event) => event.preventDefault()}
      >
        <Info size={13} strokeWidth={2} aria-hidden="true" />
      </button>
    </MenuIconTooltip>
  );
}
